import { QueryKey } from "@tanstack/react-query";

/**
 * `placeholderData` factory that keeps the previous data while the previous
 * query key still holds `scopeId` (an organization or workspace id), so range
 * and filter changes don't blank the view, but switching to another scope never
 * shows the old scope's data.
 */
export function keepPreviousDataWithinScope(scopeId: string) {
    return <TData>(
        previousData: TData | undefined,
        previousQuery: { queryKey: QueryKey } | undefined,
    ): TData | undefined =>
        previousQuery?.queryKey.includes(scopeId) ? previousData : undefined;
}
